import { useSearchParams } from 'react-router-dom'
import { applyDocumentsQueryPatch, parseDocumentsQuery } from '../utils/documentsUrlParams'
import { DocumentsQuery } from '../documents.types'

// Pushes a new history entry on every setQuery call (not replace: true) — each call is a
// discrete, completed user action, so browser back/forward can step through them.
export function useDocumentsUrlState() {
  const [searchParams, setSearchParams] = useSearchParams()

  const query = parseDocumentsQuery(searchParams)

  const setQuery = (patch: Partial<DocumentsQuery>) => {
    setSearchParams(applyDocumentsQueryPatch(searchParams, patch))
  }

  return { query, setQuery }
}
